import { CancelButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { Grid, makeStyles } from '@material-ui/core';
import ServicoIcon from 'app/assets/icon/ServicoIcon';
import { GestaoEnvioContext } from 'app/main/gestaoenvio/GestaoEnvioContext';
import parse from 'html-react-parser';
import React, { useContext } from 'react';
import { GestaoEnvioModais } from '../GestaoEnvioModais';

const useStyles = makeStyles({
  template: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    width: '100%',
  },
  documentContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    '& div': {
      display: 'block',
      wordBreak: 'break-word',
      textAlign: 'left',
      margin: '8px 0',
    },
  },
});

const VisualizarGestaoEnvioModal = () => {
  const [modal, setModal] = useContext(GestaoEnvioContext).modal;
  const [gestaoEnvioAtual] = useContext(GestaoEnvioContext).gestaoEnvioAtual;
  const styles = useStyles();

  const handleCloseModal = () => {
    setModal('');
  };

  const adicionarStyleHTML = (msg) => {
    if (!msg) return '';
    return msg.replace('<div>', '<div style="display:block; width:100%; word-wrap:break-word; text-align:left;">');
  };

  const formattedMessage = gestaoEnvioAtual?.mensagem ? adicionarStyleHTML(gestaoEnvioAtual.mensagem) : '';

  return (
    <SimpleDialog open={modal === GestaoEnvioModais.visualizarGestaoEnvio} onClose={handleCloseModal} innerScroll>
      <SimpleDialogContent
        header={{
          title: 'Detalhes do envio',
          icon: <ServicoIcon />,
          toolbar: <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>,
        }}
        contentStyle={{ padding: 0 }}
        content={
          gestaoEnvioAtual?.mensagem ? (
            <Grid item xs={12} className={styles.template}>
              <div className={styles.documentContent}>{parse(formattedMessage)}</div>
            </Grid>
          ) : (
            ''
          )
        }
      />
    </SimpleDialog>
  );
};

export default VisualizarGestaoEnvioModal;
